'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Image, TouchableWithoutFeedback, Animated} from 'react-native';
import { observer, inject } from 'mobx-react';
import styles from './style';
import {autorun} from 'mobx';
const SEARCH_BOX_ORIGIN_TOP = -262;

@inject(stores => {
    const {lowPriceDataStore} = stores,
        {fixedSearchBoxVisible, handleFixedSearchBox} = lowPriceDataStore;
    return {
        handleFixedSearchBox,
        fixedSearchBoxVisible
    };
})

@observer
class SearchBoxWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            opacity: new Animated.Value(0),
            top: new Animated.Value(SEARCH_BOX_ORIGIN_TOP)
        };

        autorun(() => {
            if(this.props.tabFix){
                setTimeout(()=>{
                    this.showModal();
                }, 0)
            }

        })
    }

    showModal = () => {
        Animated.timing(this.state.top, {
            toValue: 0,
            duration: 300
        }).start(()=>{
            this.setState({
                top: new Animated.Value(SEARCH_BOX_ORIGIN_TOP)
            })
        });
    };

    render() {
        const {tabFix, fixedSearchBoxVisible} = this.props;
        return (
            <TouchableWithoutFeedback
                onPress={()=>{this.props.handleFixedSearchBox()}}
            >
                <View style={tabFix ? (fixedSearchBoxVisible ? styles.searchBoxFix: {display: 'none'}): {}}>
                    <Animated.View style={tabFix ? [styles.searchBoxFixContainer, {top: this.state.top}]: {}}>
                        {this.props.children}
                    </Animated.View>
                </View>
            </TouchableWithoutFeedback>

        )
    }
}

export default SearchBoxWrapper;
